import { z } from 'zod';
import { customPlaceSchema } from './custom-place.schema';

export const customPlacePagedCollectionSchema = z.object({
  href: z.string().nullable(),
  offset: z.number(),
  limit: z.number(),
  size: z.number(),
  data: z.array(customPlaceSchema),
});
